import { FechaOperacionPedimentoEnum, fechaOperacionPedimentoImportacion } from "../../../common/catalogos";

const dateFilterImportacionSelect = document.getElementById("date_filter_importacion");

export const dateFilterImportacionSelectChoices = new Choices(dateFilterImportacionSelect, {
    ...choicesCommonOptions,
    ...{
        noChoicesText: "Sin tipo de fecha",
        searchEnabled: false,
        searchPlaceholderValue: "Selecciona un tipo de fecha",
        shouldSort: false,
        itemSelectText: "",
        removeItemButton: false,
    },
}).enable();

dateFilterImportacionSelectChoices.setChoices(
    fechaOperacionPedimentoImportacion.map((itm) => ({
        ...itm,
        selected: itm.clave === FechaOperacionPedimentoEnum.Pago,
    })),
    "clave",
    "descripcion",
    false,
);
